/* eslint-disable max-classes-per-file -- the auth-client error types belong together. */
// Errors thrown by auth-client (PLATFORM-988). Re-exported from auth-client.ts.

export class NotSignedInError extends Error {}
/** /auth/refresh could not give a definitive answer (5xx, network failure, malformed 200). The
 * session is NOT known to be gone: never sign out, clear state or reload because of this. */
export class RefreshUnavailableError extends Error {
  constructor(message = 'The sign-in service is temporarily unavailable.', options?: ErrorOptions) {
    super(message, options);
  }
}
/** The entitlement pre-check (POST /users/checkUserAuthorization) answered `userAuthorized: false`.
 * A definitive deny — distinct from a failure to ask. */
export class NotAuthorizedError extends Error {}
export class InvalidCredentialsError extends Error {}
export class ChallengeExpiredError extends Error {}
export class TooManyAttemptsError extends Error {}
export class InvalidPasswordError extends Error {
  policyMessage: string;

  constructor(policyMessage: string) {
    super(policyMessage);
    this.policyMessage = policyMessage;
  }
}

/** The sign-in service answered in a way the client can't use (unexpected status or body). Its
 * message is for logs; the UI shows a generic message. */
export class AuthServiceError extends Error {}
